import { useDispatch } from "react-redux";
import { ticketUpdateById, updateAmbulanceTripApi } from "../../http";
import { searchHospitals, sendWhatsappMessage, updateAmbulanceInfo } from "../../pages/actions/actions";
import { ticketDataSuccess } from "../../redux/ticketSlice/ticketSlice";
import { ticketUpdateClear, ticketUpdateStatusSuccess } from "../../redux/ticketUpdateSlice/ticketUpdateSlice";
import { EmStartNotification, createWhatsappMessagePayload, currentDateTime } from "../../utils/helper";
import { ShowAlert } from "../../utils/showAlert";
import { useLocation, useNavigate } from "react-router-dom";
import { UseGetStoreData } from "../getStoreData/UseGetStoreData";
import { useEffect, useRef, useState } from "react";
import { useEmergencyContact } from "../useEmergencyContact/UseEmergencyContact";
import { useTabHandling } from "../useTabHandling/UseTabHandling";


// import useBenDataByField from "../useBenDataByField/useBenDatabyField";

export const useLogisticsData = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [showModal, setShowModal] = useState(false);
  const { getTicketData, getTicketUpdateData, officeData, getAmbulanceTripData } = UseGetStoreData();
  const { handleTabSwitch, showOperationTab } = useTabHandling();
  // console.log('getBenList://///', getBenList);
  // const {     
  // } = UseFetchBenList({
  //   ticketData:getTicketData,
  // });
  // console.log('getTicketData:', getTicketData);
  const [isCustomDropLocationEnabled, setIsCustomDropLocationEnabled] = useState(false);
  const [officePreferred, setOfficePreferred] = useState([])
  const [selectedAddress, setSelectedAddress] = useState(null); // Set initial selected address
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [isAddressSelected, setIsAddressSelected] = useState(false)
  const [renderHospitalUi, setRenderHospitalUi] = useState(false); // this i need to store in the redux persistance storage//
  const [isHospitalSelected, setIsHospitalSelected] = useState(false);
  const [patientAddress, setPatientAddress] = useState<any>(null);
  const [patientSelectedHospital, setPatientSelectedHospital] = useState<any>(null);
  const [value, setValue] = useState(5); //actually now i handled these in parent component but i   need to handle in child without props
  const [hospitalLists, setHospitalList] = useState<any>([]);//
  const { validContacts } = useEmergencyContact()
  const [isHospitalDataLoading, setIsHospitalDataLoading] = useState(false);
  const ref = useRef<NodeJS.Timeout | null>(null);
  const location = useLocation();
  const fromPage = location.state?.from;

  const handleIncreaseRadius = async (value: any) => {
    //  console.log(' ref.current:',  ref.current);
    if (ref.current) {
      // alert("cleared")
      clearTimeout(ref.current);
    }
    ref.current = setTimeout(async () => {
      setValue(value);
      await nearByHospitalPayload({ selectedAddress, radius: value * 1000 })
    }, 1000);

  };

  // const {data:benInsuranceData}=useBenDataByField({ patient_id: getTicketData?.patient?.id, field: "insurancePolicies" })
  const marks = {
    5: "5 Kms",
    10: "10 Kms",
    20: "20 Kms",
    30: "30 Kms",
    40: "40 Kms",
    50: "50 Kms",
    60: "60 Kms",
    70: "70 Kms",
    80: "80 Kms",
    90: "90 Kms",
    100: "100 Kms",
  };

  // console.log('benInsuranceData:################################################', benInsuranceData)
  const handleAddressSelection = (selectedAddress: any) => {
    // console.log("address:", address);
    //if address don't have lat lon need to get geoCode using g_api
    //if they have then no issue;

    // alert( selectedAddress);
    if (selectedAddress?.geoLocation?.coordinates?.length || (selectedAddress?.location?.latitude && selectedAddress?.location?.longitude) || (selectedAddress?.location[0]?.latitude && selectedAddress?.location[0]?.longitude)) {

      if (fromPage === "ambulanceBooking-Pick-up Location") {
        setSelectedAddress(selectedAddress);
        updatePatientLocation(selectedAddress);
        updateAmbulance(getTicketData?._id, selectedAddress, "pickupLocation");

        // Sync to the hospital-service ambulance trip if one exists
        const lat = selectedAddress?.geoLocation?.coordinates?.[0] ?? selectedAddress?.location?.latitude;
        const lng = selectedAddress?.geoLocation?.coordinates?.[1] ?? selectedAddress?.location?.longitude;
        const addressText = transformAddressText(selectedAddress);
        if (lat && lng && getTicketData?._id) {
          syncTripPickup(addressText, [lat, lng]);
        }

        navigate("/doctor-consult-ambulance")
      } else {
        setSelectedAddress(selectedAddress);
        handlePreferredHospitalUi();
        handleNearByHospitalUi();
        buildPatientPayload(selectedAddress);

      }
    } else {
      ShowAlert("warning", 'Please select address with geoLocation')
    }

  };




  const buildPatientPayload = async (selectedAddress: any) => {

    const addressText = transformAddressText(selectedAddress);

    const payload = {
      patientLocation: {
        address: addressText,
        city: selectedAddress.city,
        landmark: selectedAddress.landmark || "",
        isLiftAvailable: selectedAddress.isLiftAvailable || false,
        isReachableByAmbulance: selectedAddress.isReachableByAmbulance || false,
        label: selectedAddress.label || "",
        geoLocation: {
          type: "Point",
          coordinates: [
            getLatitude(selectedAddress),
            getLongitude(selectedAddress)

          ],
        },
      },
    };

    dispatch(ticketUpdateStatusSuccess(payload))

    setPatientAddress(payload);
    let radius = 5000
    await nearByHospitalPayload({ selectedAddress, radius })

  }
  const nearByHospitalPayload = async ({ selectedAddress, radius }: any) => {
    const locationPayload = {
      latitude: Number(getLatitude(selectedAddress)),
      longitude: Number(getLongitude(selectedAddress)),
      radius: radius,
    };
    await getHospital(locationPayload);
  }
  const getLatitude = (address: any) => {
    if (address?.location?.latitude) return address.location.latitude;
    if (Array.isArray(address?.location) && address?.location[0]?.latitude) return address.location[0].latitude;
    if (address?.geoLocation?.coordinates) return address.geoLocation.coordinates[0];
    return null;
  };

  const getLongitude = (address: any) => {
    if (address?.location?.longitude) return address.location.longitude;
    if (Array.isArray(address?.location) && address?.location[0]?.longitude) return address.location[0].longitude;
    if (address?.geoLocation?.coordinates) return address.geoLocation.coordinates[1];
    return null;
  };
  const getHospital = async (addressPayload: {
    latitude: any;
    longitude: any;
    radius: number;
  }) => {
    setIsHospitalDataLoading(true);
    setHospitalList([]);
    try {
      const response = await searchHospitals({
        name: "",
        PickupLatitude: addressPayload.latitude,
        PickupLongitude: addressPayload.longitude,
        radius: addressPayload.radius
      });
      if (response) {
        setHospitalList(response.data);
        setIsHospitalDataLoading(false);
      }
    } catch (e: any) {
      console.log(' e:', e)
      setIsHospitalDataLoading(false);
      ShowAlert("warning", e.response.data.message || "some issue while getting hospital list")
    }

  };
  const preParePatientLocation = (selectedAddress: any) => {
    const addressText = transformAddressText(selectedAddress);
    const payload = {
      patientLocation: {
        address: addressText,
        city: selectedAddress.city,
        landmark: selectedAddress.landmark || "",
        isLiftAvailable: selectedAddress.isLiftAvailable || false,
        isReachableByAmbulance: selectedAddress.isReachableByAmbulance || false,
        label: selectedAddress.label || "",
        geoLocation: {
          type: "Point",
          coordinates: [
            getLatitude(selectedAddress),
            getLongitude(selectedAddress)

          ],
        },
      },
    };

    return payload;


  }
  const updatePatientLocation = async (selectedAddress: any) => {
    try {
      let payload = preParePatientLocation(selectedAddress);
      if (payload) {
        // const res=await updateTicket();
        const response = await ticketUpdateById(getTicketData._id, payload)
        if (response) {
          dispatch(ticketDataSuccess(response.data));
          dispatch(ticketUpdateClear());
        }
      }
    } catch (e) {
      return Error("some issue while updating patient location")

    }


  }
  //  console.log('selectedAddress:', selectedAddress);
  // const cacheFilterHospital = (hospitalList: any,key:string) => {
  //   // const getInsureanceDetails=benInsuranceData;
  //   backgroundTask(() => {
  //     const filtered = hospitalList.filter((el: any) => el?.handleEmergency);
  //     storeDataInSessionStorage(`${key}_E`, filtered);
  //   }, 0);

  //   backgroundTask(() => {
  //     const insurerNamesSet = new Set(benInsuranceData.map((insurance: any) => insurance.nameOfInsurer));
  //     const matchedHospitals = hospitalList.filter((el: any) =>
  //       el.insuranceList?.some((insurer: string) => insurerNamesSet.has(insurer))
  //     );
  //     storeDataInSessionStorage(`${key}_E`, matchedHospitals);
  //   }, 0);

  // }


  const transformAddressText = (selectedAddress: any) => {
    let addressText = `${selectedAddress?.addressLine2 || ""}, ${selectedAddress.addressLine1 || selectedAddress?.address || ""
      }, ${selectedAddress.city}, ${selectedAddress.state}, ${selectedAddress.pinCode
      }`;
    return addressText;

  }

  const updateAmbulance = async (ticketId: any, selectedAddress: any, key: string) => {
    try {
      let payload = {
        address: transformAddressText(selectedAddress),
        city: selectedAddress.city,
        label: selectedAddress.label || "custom",
        location: {
          type: "Point",
          coordinates: [
            selectedAddress?.geoLocation?.coordinates[0] || selectedAddress?.location?.longitude,
            selectedAddress?.geoLocation?.coordinates[1] || selectedAddress?.location?.latitude
          ]
        }
      }

      await updateAmbulanceInfo(ticketId, { [key]: payload });

    } catch (e) {
      console.log(e);
    }

  }

  const updateAmbulanceDropLocation = async (ticketId: any, dropLocation: any, patientSelectedHospital: any) => {
    try {
      let payload = {
        hospitalName: patientSelectedHospital?.hospitalInfo?.hospitalName,
        address: dropLocation?.address,
        city: dropLocation?.city,
        label: dropLocation?.label || "custom",
        location: {
          type: "Point",
          coordinates: [
            dropLocation?.geoLocation?.coordinates[0] || dropLocation?.location?.longitude,
            dropLocation?.geoLocation?.coordinates[1] || dropLocation?.location?.latitude
          ]
        }
      }

      await updateAmbulanceInfo(ticketId, { dropLocation: [payload] });
    }
    catch (e) {
      console.log(e);
    }
  }

  // ── Sync location changes to the hospital-service ambulance trip ─────────
  // Uses the trip _id from the Redux store — no extra API fetch needed.
  const syncTripPickup = async (address: string, coordinates: number[]) => {
    const tripId = getAmbulanceTripData?._id;
    if (!tripId) return;
    try {
      await updateAmbulanceTripApi(tripId, {
        pickupLocation: { address, coordinates },
      });
    } catch {
      // non-blocking — ticket service is already updated
    }
  };

  const syncTripDrop = async (address: string, coordinates: number[]) => {
    const tripId = getAmbulanceTripData?._id;
    if (!tripId) return;
    try {
      await updateAmbulanceTripApi(tripId, {
        dropLocation: [{ address, coordinates }],
      });
    } catch {
      // non-blocking
    }
  };


  const handleSelectHospital = async (address: any) => {
    // console.log('address:', address);
    // alert("check")


    if (fromPage === "ambulanceBooking-Drop Location") {
      const payload = selectedHospitalPayload({ selectedHospital: address });
      let response = await ticketUpdateById(getTicketData._id, patientSelectedHospital || payload);
      dispatch(ticketDataSuccess(response.data));
      dispatch(ticketUpdateClear());
      setPatientAddress(null);
      setPatientSelectedHospital(null);
      setIsCustomDropLocationEnabled(false);
      updateAmbulanceDropLocation(getTicketData._id, selectedAddress, patientSelectedHospital);

      // Sync to the hospital-service ambulance trip if one exists
      const hospitalCoords: number[] | undefined =
        (patientSelectedHospital || payload)?.hospitalInfo?.geoLocation?.coordinates;
      const hospitalAddress =
        (patientSelectedHospital || payload)?.hospitalInfo?.hospitalName
          ? `${(patientSelectedHospital || payload).hospitalInfo.hospitalName}, ${(patientSelectedHospital || payload).hospitalInfo.address}`
          : (patientSelectedHospital || payload)?.hospitalInfo?.address;
      if (hospitalCoords?.length === 2 && getTicketData?._id) {
        syncTripDrop(hospitalAddress, hospitalCoords);
      }

      navigate("/doctor-consult-ambulance")
    } else if (fromPage === "extraCharges-Drop Location") {
      navigate("/extra-charges", { state: { from: 'extraCharges-Drop Location', selectedHospital: address } });
    } else {
      setSelectedHospital(address);
      setIsHospitalSelected(!isHospitalSelected)
      handleNearByHospitalUi();
      selectedHospitalPayload({ selectedHospital: address })

    }
  }
  const getHospitalContact = (contact: any) => {
    return contact?.map((el: any) => {
      return (
        el.contact
      )
    });
  }
  const selectedHospitalPayload = ({ selectedHospital }: any) => {
    const hospitalContact = getHospitalContact(selectedHospital?.contacts);
    const payload = {
      hospitalInfo: {
        hospitalName: selectedHospital.name,
        address: selectedHospital.address,
        contactNumber: hospitalContact?.join(","),
        hospitalContacts: selectedHospital?.contacts,
        geoLocation: {
          type: "Point",
          coordinates: [selectedHospital?.location?.coordinates[1], selectedHospital?.location?.coordinates[0]],
        },
      },
    }
    setPatientSelectedHospital(payload);
    return payload;
  }
  const handleEditSelectedAddress = async () => {
    setIsAddressSelected(false);
    setIsHospitalSelected(false);
    setRenderHospitalUi(false);
    setSelectedHospital(null);
  };

  const handlePreferredHospitalUi = () => {
    setValue(5);
    setIsAddressSelected(!isAddressSelected);
    isHospitalSelected && setIsHospitalSelected(!isHospitalSelected)
    renderHospitalUi && setRenderHospitalUi(!renderHospitalUi)
  }
  const handleNearByHospitalUi = () => {
    setRenderHospitalUi(!renderHospitalUi)
    // setRenderSelectedHospitalUi(!renderSelectedHospitalUi);
  };
  const handleEditHospital = () => {
    setIsHospitalSelected(!isHospitalSelected);
    handleNearByHospitalUi();

  }


  // console.log("selectedAddress:", selectedAddress);
  const handleStartEmergency = async () => {
    const patientName = getTicketData?.patient?.fullName || getTicketUpdateData?.patient?.fullName;
    let notifyEmPayload = {
      beneficiary: patientName,
      to: [...validContacts]
    };
    const notifyEmTemplate = createWhatsappMessagePayload({ templateName: "NOTIFY_EC_ON_EMERGENCY", data: notifyEmPayload });
    // console.log('notifyEmTemplate:', notifyEmTemplate)
    const TicketUpdateTracking = {
      notes: [...getTicketData?.notes, {
        date: currentDateTime(),
        message: "Emergency Started"
      }]
    };
    await updateTicket({ ticketId: getTicketData._id, ticketPayload: { ...patientAddress, ...patientSelectedHospital, ...TicketUpdateTracking }, templatePayload: notifyEmTemplate });
    ShowAlert("success", EmStartNotification);
    return navigate("/doctor-consult-ambulance")
  }
  const updateTicket = async ({ ticketId, ticketPayload, templatePayload }: any) => {
    try {
      if (ticketId) {
        const response = await ticketUpdateById(ticketId, ticketPayload);
        if (response) {
          sendWhatsAppMessageToEm(templatePayload);
          dispatch(ticketDataSuccess(response.data));
          dispatch(ticketUpdateClear());
          // setShowModal(true)
          // sendWhatsAppMessageToEm(sendWhatsappMessagePayload);
        }
      }
    } catch (e) {
      return alert("some Technical Issue");
    }
  }

  const sendWhatsAppMessageToEm = async (payload: any) => {
    try {
      const response = await sendWhatsappMessage(payload);
      if (response) {
        // setIsLoading(true)
      }
    } catch (e: any) {
      alert(e?.response?.data?.message || "Some Technical Issue In sending Wa Msg")
    }
  };
  useEffect(() => {
    if (getTicketData?.currentMedicalStatusResponse?.isAmbulanceRequired === "No") {
      return navigate("/doctor-consult-ambulance")
    }
  }, [getTicketData, navigate])

  useEffect(() => {
    setOfficePreferred(officeData?.preferredHospital)

    async function fetchData(selectedAddress: any) {
      let radius = 5000
      await nearByHospitalPayload({ selectedAddress, radius })


    }
    if (fromPage === "ambulanceBooking-Drop Location" || fromPage === "extraCharges-Drop Location") {
      let selectedAddress = getTicketData?.patientLocation;
      let dropLocation = {
        patientLocation: selectedAddress,
      };
      setPatientAddress(dropLocation);
      setSelectedAddress(getTicketData?.patientLocation);
      handlePreferredHospitalUi();
      fetchData(selectedAddress);
      handleNearByHospitalUi();

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return { isAddressSelected, selectedAddress, setSelectedAddress, handleAddressSelection, handleEditSelectedAddress, isHospitalSelected, selectedHospital, handleEditHospital, renderHospitalUi, value, handleIncreaseRadius, marks, patientAddress, hospitalLists, handleSelectHospital, handleStartEmergency, handleTabSwitch, showOperationTab, getTicketData, isHospitalDataLoading, officePreferred, isCustomDropLocationEnabled, setIsCustomDropLocationEnabled, getTicketUpdateData, fromPage }
}